import moment from 'moment';

export const nextPageParam = (lastPage: any): number | undefined => {
  const { currentPage, data } = lastPage || {};
  if (currentPage < data?.totalPages) {
    return currentPage + 1;
  }
  return undefined;
};

export const dateTimeFormatForDI = (value: any) => {
  return moment(value).format("Do MMMM 'YY [at] h:mm a");
};